import httpClient from "../../../../api/httpClient";
import Cookies from "js-cookie";

/**
 * Uploads an Excel file for bulk contract creation.
 *
 * @param {string} officeCode - The office code (e.g., "OFFC_101").
 * @param {File} selectedFile - The Excel file to upload.
 * @returns {Promise} Axios response promise
 */

export const bulkUploadApi = {
  // Upload Excel (multiple officeCodes)
  uploadContractsExcel: (officeCodes, selectedFile) => {
    const formData = new FormData();
    formData.append("file", selectedFile);

    // Build query string: authorizedOfficeCodes=CODE1&authorizedOfficeCodes=CODE2
    const params = new URLSearchParams();
    officeCodes.forEach((code) => params.append("authorizedOfficeCodes", code));

    return httpClient.post(
      `${
        process.env.REACT_APP_API_BASE_URL
      }/api/bulk-upload/organizations?${params.toString()}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
  },

  // Export contracts (single officeCode)
  downloadContracts: (officeCode) => {
    return httpClient
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/api/bulk-upload/organizations/export?officeCode=${officeCode}`,
        { responseType: "blob" }
      )
      .then((response) => response.data);
  },

  updateContractsExcel: (officeCodes, selectedFile) => {
    const formData = new FormData();
    formData.append("file", selectedFile);

    return httpClient.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/bulk-upload/organizations/rates/createOrUpdate`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("authToken")}`,
          "Office-Code": officeCodes.join(","),
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
};
